const ERROR_KEY = '_error';

const transformErrors = err => {
  if (typeof err === 'string') {
    return { type: 'manual', message: err };
  }

  if (Array.isArray(err)) {
    let hasError = false;
    const result = err.map(e => {
      const transformed = e ? transformErrors(e) : undefined;
      if (transformed !== undefined) hasError = true;
      return transformed;
    });

    if (err[ERROR_KEY]) {
      result.root = { type: 'manual', message: err[ERROR_KEY] };
      hasError = true;
    }

    return hasError ? result : undefined;
  }

  if (typeof err === 'object' && err !== null) {
    if (err[ERROR_KEY] && Object.keys(err).length === 1) {
      return { type: 'manual', message: err[ERROR_KEY] };
    }

    const result = {};
    let hasError = false;

    Object.keys(err).forEach(key => {
      if (key === ERROR_KEY) {
        result.root = { type: 'manual', message: err[ERROR_KEY] };
        hasError = true;
      } else {
        const transformed = transformErrors(err[key]);
        if (transformed !== undefined) {
          result[key] = transformed;
          hasError = true;
        }
      }
    });

    return hasError ? result : undefined;
  }

  return undefined;
};

export const reduxFormResolver = validate => async (values, context) => {
  const errors = validate(values, context || {});

  const rhfErrors = {};
  Object.keys(errors).forEach(key => {
    const transformed = transformErrors(errors[key]);
    if (transformed !== undefined) {
      rhfErrors[key] = transformed;
    }
  });

  return {
    values: Object.keys(rhfErrors).length === 0 ? values : {},
    errors: rhfErrors
  };
};
